<template>
  <b-overlay :show="loading">
    <form data-vv-scope="user">
      <div class="row mt-5">
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100 cursor-default"
            label="Rut"
            maxlength="12"
            name="iut"
            v-model="cuUserData.iut"
            readonly
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100 cursor-default"
            label="Nombres"
            maxlength="250"
            name="name"
            v-model="cuUserData.name"
            readonly
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100 cursor-default"
            label="Apellido Paterno"
            maxlength="200"
            name="lastName"
            v-model="cuUserData.lastName"
            readonly
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100 cursor-default"
            label="Apellido Materno"
            maxlength="250"
            name="mothersLastName"
            v-model="cuUserData.mothersLastName"
            readonly
          />
        </div>
        <div class="col-12 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Dirección"
            maxlength="250"
            name="address"
            v-model="cuUserData.address"
            :danger="errors.has('user.address')"
            :danger-text="errors.first('user.address')"
            v-validate="'required'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Número Documento / Número de serie"
            maxlength="200"
            name="iutNumber"
            v-model="cuUserData.iutNumber"
            :danger="errors.has('user.iutNumber')"
            :danger-text="errors.first('user.iutNumber')"
            v-validate="'required'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Correo Personal"
            maxlength="250"
            name="email"
            v-model="cuUserData.email"
            :danger="errors.has('user.email')"
            :danger-text="errors.first('user.email')"
            v-validate="'required|email'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Teléfono fijo"
            maxlength="20"
            name="landline"
            v-model="cuUserData.landline"
            :danger="errors.has('user.landline')"
            :danger-text="errors.first('user.landline')"
            v-validate="'required|numeric'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Teléfono móvil"
            maxlength="25"
            name="phone"
            v-model="cuUserData.phone"
            :danger="errors.has('user.phone')"
            :danger-text="errors.first('user.phone')"
            v-validate="'required|numeric'"
          />
        </div>
        <div class="col-6 mt-2">
          <vs-select
            placeholder="Seleccione estado civil"
            class="w-100 con-select autocompletex"
            label="Estado Civil"
            name="civilStatus"
            v-model="cuUserData.civilStatus"
            :danger="errors.has('user.civilStatus')"
            :danger-text="errors.first('user.civilStatus')"
            v-validate="'required'"
          >
            <vs-select-item
              value="Soltero"
              text="Soltero"
            />
            <vs-select-item
              value="Casado"
              text="Casado"
            />
          </vs-select>
        </div>
        <div class="col-6 mt-2">
          <vs-input
            autocomplete="off"
            label="Fecha de nacimiento"
            class="w-100"
            placeholder="Ejemplo: 1995-12-20 (significa 20 de diciembre de 1995)"
            maxlength="10"
            name="birthday"
            v-model="cuUserData.birthday"
            :danger="errors.has('user.birthday')"
            :danger-text="errors.first('user.birthday')"
            v-validate="'required|date_format:yyyy-mm-dd'"
          />
        </div>
      </div>
      <div class="text-right mt-4">
        <b-button
          v-if="!getCertificate"
          variant="primary"
          @click="getSecurityQuestions"
        >
          Solicitar
        </b-button>
        <div class="text-right mt-4" v-if="getCertificate">
          <b-button
            variant="success"
            @click="getCertificateRequest"
          >
            Solicitar certificado
          </b-button>
        </div>
      </div>
    </form>
    <b-modal
      size="lg"
      ref="questions"
      hide-footer
      no-close-on-backdrop
      title="Preguntas de seguridad"
    >
      <SecurityQuestions
        :securityQuestions="securityQuestions"
        :getCertificate="getCertificate"
        :loading="loading"
        :is-external="true"
        :cuUserData="cuUserData"
        @loading="loading = $event"
        @closeModal="closeModal"
      />
    </b-modal>
  </b-overlay>
</template>
<script>
import { mapGetters } from 'vuex';

import SecurityQuestions from './SecurityQuestions';

import { cuEsignCertifiedExternal, cuVerificationInfoExternal } from "@/febos/servicios/api/v2.aprobaciones.api";
import securityQuestionsDummy from './segurityQuestionsDummy';

export default {
  name: 'VerificationForm',
  components: {
    SecurityQuestions
  },
  data() {
    return {
      securityQuestionsDummy,
      max: this.$moment().format('YYYY-MM-DD'),
      loading: false,
      getCertificate: false,
      securityQuestions: {}
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    token() {
      const { token } = this.$route.params;
      return token;
    }
  },
  methods: {
    closeModal() {
      this.$refs.questions.hide();
      this.getCertificate = true;
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async getSecurityQuestions() {
      const isValid = await this.validateForm('user');
      if (!isValid) {
        return;
      }
      const { idProceso } = this.$route.query;
      this.loading = true;
      try {
        const response = await cuVerificationInfoExternal({
          params: {
            tipo: 'esign7',
            accion: 'challenge',
            debug: ''
          },
          headers: {
            Authorization: this.token,
          },
          body: {
            idProceso,
            apellidoMaterno: this.cuUserData.mothersLastName,
            apellidoPaterno: this.cuUserData.lastName,
            correoPersonal: this.cuUserData.email,
            direccion: this.cuUserData.address,
            estadoCivil: this.cuUserData.civilStatus,
            fechaNacimiento: this.cuUserData.birthday,
            isOk: true,
            nombres: this.cuUserData.name,
            numeroSerie: this.cuUserData.iutNumber,
            rut: this.cuUserData.iut,
            telefonoMovil: this.cuUserData.phone
          }
        });
        this.securityQuestions = response.data.preguntas; // TODO: poner el dummy
        // this.securityQuestions = securityQuestionsDummy.preguntas;
        this.loading = false;
        await this.$refs.questions.show();
      } catch {
        this.loading = false;
      }
    },
    async getCertificateRequest() {
      const { idProceso } = this.$route.query;
      try {
        this.loading = true;
        await cuEsignCertifiedExternal({
          params: {
            accion: 'verificar',
            debug: '',
            tipo: 'esign7'
          },
          headers: {
            Authorization: this.token
          },
          body: {
            idProceso,
            apellidoMaterno: this.cuUserData.mothersLastName,
            apellidoPaterno: this.cuUserData.lastName,
            correoPersonal: this.cuUserData.email,
            direccion: this.cuUserData.address,
            estadoCivil: this.cuUserData.civilStatus,
            fechaNacimiento: this.cuUserData.birthday,
            isOk: true,
            nombres: this.cuUserData.name,
            numeroSerie: this.cuUserData.iutNumber,
            rut: this.cuUserData.iut,
            telefonoMovil: this.cuUserData.phone
          }
        });
        await this.$router.push({ name: 'signature-external-file', query: { idProceso: idProceso } });
        this.$bvToast.toast(
          'Genial! Se ha solicitado el certificado exitosamente!',
          { title: 'Certificado', variant: 'info' }
        );
        this.loading = false;
      } catch {
        this.loading = false;
      }
    }
  },
  props: {
    cuUserData: { type: Object }
  },
};
</script>
<style>

</style>
